// components/Layout.js
import React, { useEffect, useState } from "react";
import { AdminHeader, AdminSidebar, Header, Sidebar } from "./components";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import messageTable from "./components";

const Layout = ({ children }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const isTableFullScreen = useSelector(
    (state) => state.application.isTableFullScreen
  );
  const location = useLocation();
  useEffect(() => {
    isTableFullScreen ? setIsSidebarOpen(false) : setIsSidebarOpen(true);
  }, [isTableFullScreen]);

  return (
    <div className="bg-main min-h-screen w-full h-full flex">
      {location.pathname.includes("admin") ? (
        <AdminSidebar isOpen={isSidebarOpen} setIsOpen={setIsSidebarOpen} />
      ) : (
        <Sidebar isOpen={isSidebarOpen} setIsOpen={setIsSidebarOpen} />
      )}

      <div
        className={`flex-grow ${
          isSidebarOpen
            ? location.pathname.includes("admin")
              ? "ml-0 mt-[90px]"
              : "ml-0 lg:ml-80"
            : "ml-0"
        }   transition-all duration-300`}
      >
        {location.pathname.includes("admin") ? (
          <AdminHeader isOpen={isSidebarOpen} setIsOpen={setIsSidebarOpen} />
        ) : (
          <>
            <div className="sticky top-0 z-50 w-full ">
              <Header isOpen={isSidebarOpen} setIsOpen={setIsSidebarOpen} />
            </div>
          </>
        )}
        <main>{children}</main>
      </div>
    </div>
  );
};

export default Layout;
